import type { UserProfile } from './user';

export const canAdministerAccount = (user: UserProfile | null | undefined): boolean => user?.role === 'admin';

export const canCreateNewsfeedPost = (user: UserProfile | null | undefined): boolean =>
  user?.role === 'admin' || user?.role === 'manager';

// Account admins (and legacy multi-account admins) work across every store of the account, as in khova-api.
export const hasAccountWideAccess = (user: UserProfile | null | undefined): boolean =>
  user?.role === 'admin' || user?.role === 'multiadmin';
